// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgMicError16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7 1.5C5.89543 1.5 5 2.39543 5 3.5V7.5C5 8.60457 5.89543 9.5 7 9.5C8.10457 9.5 9 8.60457 9 7.5V3.5C9 2.39543 8.10457 1.5 7 1.5ZM11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9V6ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM7.5 15V11.9739C8.19408 11.9009 8.84129 11.6777 9.40429 11.3389L9.4 10.1225C8.77605 10.6664 7.92251 11 7 11C5.06081 11 3.5 9.52602 3.5 7.72253V5.27747H2.5V7.72253C2.5 9.93006 4.25483 11.7377 6.5 11.9739V15H7.5Z"
				/>
			</Svg>
		);
	}
);
SvgMicError16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgMicError16;
